
<template>
  <v-content>
    <v-container fluid v-if="loggedin && isAuthenticated">
      <Header :title="title" />
      <v-row class="mt-n3" v-if='Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) )'>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-card
            class="ma-4 pa-1 clickable-entity"
            width=260
            elevation="0"
            color="#fafafa"
            @click="userList=true"
          >
            <v-list-item>
                <v-list-item-content >
                  <v-card-title class="ml-4 pa-0" style="font-size: 30px;"> {{users.length}} </v-card-title>
                  <v-card-text class="ml-4 pa-0"> {{"Users Logged In" | translate}} </v-card-text>
                </v-list-item-content>
                <v-icon color="blue" style="font-size: 60px;">mdi-account </v-icon>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
                 
                  <div class="row">
                    <div class="col">
                      <div class="d-flex flex-wrap"> 
                        <template>
                          
                          <v-card
                                class="ma-4 pa-1"
                                width=260
                                :elevation=2
                                v-if=lastmoduleVisitedId
                          >
                            <v-list-item>
                              <v-row justify="end">
                              <v-list-item-content>
                                <v-card-text style="font-size: 16px;font-weight: 500;"  class="ml-4 mb-4 pa-0"> {{"Continue Learning" | translate}} </v-card-text>
                                <v-card-subtitle class="ml-4 pa-0"> <v-icon color="blue" @click="modulePlayer(lastcourseVisitedId,lastmoduleVisitedId)">mdi-play-circle </v-icon> <span class="font-weight-light clickable-entity" @click="modulePlayer(lastcourseVisitedId,lastmoduleVisitedId)">{{ lastmoduleName }}</span></v-card-subtitle>
                              </v-list-item-content>
                              </v-row>
                            </v-list-item>
                          </v-card>  

                          <DashCard type="LastLoggedIn" title="Last Logged In" description="The day you last logged in" color="#c39797" :value=convertDate(currentUser.last_login) :width=260 />
                          <DashCard type="Subscriptions" title="Courses Subscribed" description="Courses that you have subscribed to" color="green" :value=String(coursesdata.length) :width=260 />
                          <DashCard type="BreachedDocuments" title="Breached Documents" description="Number of documents expired. Please update your documents" color="red" :value="(dashboardstats.length != 0) ? String(dashboardstats.breached_doc_count) : 'Loading...'" :width=260 />
                          <DashCard class="calendar-card" @clicking="clicking" type="Calendars" :title="(dashboardstats.length != 0) ? (String((dashboardstats.upcoming_event && dashboardstats.upcoming_event.length != 0) ? ((dashboardstats.upcoming_event.subject).replace(/##.*?##/g, '') +' on ' + convertfromTztoDate(dashboardstats.upcoming_event.start.dateTime)) : 'No Event')) : 'Loading...'" description="Next Event on your calendar" color="blue" :value="'Upcoming Events' | translate" :width=260 />
                          <DashCard v-if="(dashboardstats.length != 0) && dashboardstats.down_time_event" type="Calendars" :title="dashboardstats.down_time_event.subject + ' on ' + convertfromTztoDate(dashboardstats.down_time_event.start.dateTime) " description="Information on when the site will be down/shut/unreachable" color="#f88c9b" :value="'Downtime Calendar'" :width=1136 />
                          
                        </template>
                      </div>
                    </div>
                  </div> 


                  <div class="row" >
                      <div class="col-md-8" >
                          <v-card class="daily-quiz-bar-chart">
                            <template>
                                <BarChart 
                                :chart-data="chartData"
                                :height=300
                                />
                                <v-btn class="white--text flexible-button" small :color="primary_color" x-large block @click="callDailyQuiz()"> {{ "Take Daily Quiz" | translate  }}</v-btn>
                            </template>
                          </v-card>
                      </div>
                      
                      <div class="col-md-4">
                        <template>
                          <v-card
                            class="mx-auto overflow-auto"
                            max-width="350"
                            max-height="450"
                            height="450"
                          >
                            <v-toolbar
                              :color="primary_color"
                              dark
                            >
                              <v-toolbar-title>{{ "Last Courses Visited" | translate}}</v-toolbar-title>
                            </v-toolbar>
                            <v-list two-line v-if="lastcoursesdata.length">
                                <v-list-group
                                  v-for="(item, index) in lastcoursesdata"
                                  :key="index"
                                  v-model="item.active"
                                  :prepend-icon="item.action"
                                  no-action
                                >
                                    <template v-slot:activator>
                                      <v-list-item-content>
                                          <v-list-item-title v-text="item.course_name"></v-list-item-title>
                                          <v-list-item-subtitle :class="item.active ? 'text-blue':'text--primary'">{{item.company_modules.length}}{{'Modules' | translate}}</v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>

                                    <template>
                                      <v-list dense>
                                        <v-list-item-group
                                          v-model="selectedItem"
                                          color="primary"
                                        >
                                          <v-list-item
                                            v-for="(mod,i) in item.company_modules"
                                            :key="i"
                                          >
                                            <v-btn class="book-button" rounded fab icon v-if="mod.show_module" @click="modulePlayer(mod.course_id,mod.module_id)"><v-icon>mdi-play-circle </v-icon> </v-btn>
                                            <v-btn class="book-button" rounded fab icon @click="lockMessage=true" lockMessage v-else>  <v-icon>mdi-lock </v-icon></v-btn>

                                            <v-list-item-content>
                                              <v-list-item-title v-text="mod.title"></v-list-item-title>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </v-list-item-group>
                                      </v-list>
                                    </template>
                                </v-list-group>
                            </v-list>
                            <div v-else class="pa-4">
                              {{ "No data found" | translate}}
                            </div>
                          </v-card>
                        </template>
                      </div>
                  </div>

                  <div class="row" v-if="!isLoadingStats">
                    <div class="col">
                      <template>
                        <v-card
                          class="ma-4 pa-1"
                          v-for="(courses, courseindex) of coursesdata" :key="courseindex"
                        >
                          <v-row>
                            <v-col class="col-md-6">

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-chip
                                      class="ma-2"
                                      color="#f08cc0"
                                      label
                                      text-color="white"
                                    >
                                      <v-icon>mdi-clock </v-icon> 
                                      {{"Expires on:" | translate}} {{ convertDate(courses.expires_on) }}
                                    </v-chip>
                                  </v-card-actions>

                                  <v-card-title class="clickable-entity" style="min-height: 30px;" v-on:click="viewCourseDetails(courses.course_id)">
                                    {{courses.course_name}}
                                  </v-card-title>

                                  <v-card-subtitle class="text-subtitle-1" style="min-height: 30px;" v-on:click="viewCourseDetails(courses.course_id)">
                                    {{courses.description}}
                                  </v-card-subtitle>

                                  <v-card-text>
                                    <v-row>
                                      <v-col class="col-md-12 d-flex flex-wrap">
                                      <div class="kpicards ma-2 pa-5 text-center timespent" v-bind:style="{'background-color':'#f7f7f7'}"><h4>{{ 'Time Spent' | translate }}</h4>
                                         <v-icon :color="primary_color" size="35" class="mt-2" v-text="'mdi-clock'"></v-icon>
                                         <v-spacer></v-spacer>
                                         {{courses.time_spent ? courses.time_spent : $t("Not Started")}} 
                                      </div>

                                      <div class="kpicards ma-2 pa-5 text-center progress" v-bind:style="{'background-color':'#f7f7f7'}">
                                        <h4 v-if="!courses.is_passed && (courses.show_exam==true)">{{ 'Exam Ready' | translate }}</h4>
                                        <h4 v-else>{{ 'Progress' | translate }}</h4>
                                        <v-progress-circular
                                          :rotate="360"
                                          :size="40"
                                          :width="4"
                                          :color="primary_color"
                                          class="mt-2"
                                          :value=courses.course_progress
                                          v-if="!courses.is_passed && !courses.show_exam"
                                        >
                                          {{ courses.course_progress +'%' }}
                                        </v-progress-circular>      
                                        <v-icon
                                          color="success"
                                          size="35"
                                          class="mt-2"
                                          v-text="'mdi-checkbox-marked-circle'"
                                          v-if="courses.is_passed && !courses.show_exam"
                                        ></v-icon> 
                                        <v-btn class="pa-3 mt-4" :style="{'color':primary_color}"
                                          x-small
                                          rounded
                                          outlined
                                          :color="primary_color"
                                          v-if="!courses.is_passed && (courses.show_exam==true)"
                                          @click="callExam(courses.course_id)"  
                                        >
                                          <v-icon size="large">mdi-note-outline</v-icon>{{"Take Exam"| translate}}
                                        </v-btn>
                                      </div>

                                      <div class="kpicards ma-2 pa-5 text-center" v-bind:style="{'background-color':'#f7f7f7'}"><h4>{{ 'Last Session' | translate }}</h4>
                                        <v-icon :color="primary_color" size="35" class="mt-2" v-text="'mdi-desktop-mac'"></v-icon> 
                                        <v-spacer>
                                        </v-spacer>
                                        {{courses.last_session?convertSession(courses.last_session): $t('Not Logged') }}
                                      </div>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>

                                  <v-card-actions class="mr-12">
                                    <v-btn
                                      :style="{'color':primary_color}"
                                      small
                                      rounded
                                      outlined
                                      v-if="courses.is_passed && courses.has_survey"
                                      @click="callSurvey(courses.course_id)"
                                      class="mx-1 pa-1"
                                    >
                                    <v-icon>mdi-clipboard-list</v-icon>
                                    <span class="mx-2 ml-2">{{ "Take Survey" | translate }}</span>
                                    </v-btn>
                                  <v-spacer></v-spacer>

                                    <v-btn
                                      :style="{'color':primary_color}"
                                      small
                                      rounded
                                      outlined
                                      :to="'/course/'+courses.course_id" 
                                      class="mx-1 pa-1"
                                    >
                                    <v-icon>mdi-eye</v-icon>
                                    <span class="mx-2 ml-2">{{ "Course Details" | translate }}</span>
                                    </v-btn>

                                    <v-btn
                                      :style="{'color':primary_color}"
                                      small
                                      rounded
                                      outlined
                                      :to="'/course/'+courses.course_id" 
                                      v-if="courses.course_progress>0"
                                      @click="modulePlayer(courses.course_id,courses.in_progress_module)"
                                      class="mx-1 pa-1"
                                    >
                                    <v-icon>mdi-motion-play-outline</v-icon>
                                    <span class="mx-2 ml-2">{{ "Resume Learning" | translate }}</span>
                                    </v-btn>
                             
                                    <v-btn
                                      :style="{'color':primary_color}"
                                      small
                                      rounded
                                      v-if="!courses.course_progress"
                                      @click="modulePlayer(courses.course_id,courses.in_progress_module)"
                                      class="mx-0 pa-0"
                                    >
                                    <v-icon>mdi-play-circle-outline</v-icon>
                                    <span class="mx-2 ml-2">{{ "Start" | translate }}</span>
                                    </v-btn>
                               
                                  </v-card-actions>

                            </v-col>
                            <v-col class="col-md-6">
                              <template>
                                <v-card 
                                class="mx-auto overflow-auto"
                                max-height="450"
                                height="300"
                                >
                                  <v-tabs :color="primary_color"  v-model="openedTab[courses.course_id]" style="position: sticky; top: 0;  z-index: 2;">
                                    <v-tab href="#viewmodtab"> {{ 'Modules' | translate }} </v-tab>
                                    <v-tab href="#viewquiztab" v-if="has_quiz == true" @click="getQuizData(courseindex, null, null, courses.course_id)"> {{ 'Quiz' | translate}} </v-tab>
                                    <v-tab href="#viewexertab"> {{ 'Exercise' | translate}} </v-tab>
                                    <v-tab href="#vieweventstab" @click="getEventsData(courses.course_id)"> {{ 'Events' | translate}} </v-tab>
                                    <v-tab href="#viewlmtab" @click="openDocumentPanel('search'+courses.course_id,courses.course_id)"> {{ 'Learning' | translate }} </v-tab>
                                  </v-tabs>
                                  <v-tabs-items v-model="openedTab[courses.course_id]">
                                    <v-tab-item value="viewmodtab" :active="true">
                                      <v-list dense
                                          v-for="(mod,moduleindex) in courses.company_modules"
                                          :key="moduleindex"
                                          v-model="mod.active"
                                      >
                                        <v-list-group
                                          v-if="mod.show_quiz"  
                                          v-on:click.stop="getQuizData(courseindex,moduleindex,mod.module_id,courses.course_id)" lockMessage
                                        >
                                          <template v-slot:activator>
                                                <v-btn class="book-button" rounded fab  icon v-if="mod.show_module" @click="modulePlayer(mod.course_id,mod.module_id)"><v-icon>mdi-play-circle </v-icon></v-btn>
                                                <v-btn class="book-button" rounded fab  icon @click="lockMessage=true" lockMessage v-else ><v-icon>mdi-lock </v-icon></v-btn>
                                                <v-list-item-title :class="mod.active ? 'text-blue':'text--primary'" v-text="mod.title"></v-list-item-title>
                                                <v-btn class="pa-2 mr-2" :style="{'color':primary_color}"
                                                  x-small
                                                  rounded
                                                  outlined
                                                  :color="primary_color"
                                                  v-if="(mod.company_tests!=null)"
                                                  @click="callTest(mod.course_id,mod.module_id)"  
                                                >
                                                  <v-icon>mdi-note-outline</v-icon>{{"Take Test"| translate}}
                                                </v-btn>
                                                <v-btn class="pa-3" x-small rounded outlined :color="primary_color">
                                                  <v-icon size="large">mdi-frequently-asked-questions </v-icon>{{"Take Quiz"| translate}}
                                                </v-btn>
                                          </template>
                            
                                          <v-list-item-group
                                            v-if="timesessiondata[courses.course_id]"
                                            color="primary"
                                            class="ml-12"
                                          >
                                            <v-list-item
                                            v-for="(time,timeindex) of timesessiondata[courses.course_id][moduleindex]"
                                            :key="timeindex"
                                            >
                                            <v-list-item-icon>
                                              <v-icon>mdi-frequently-asked-questions</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title @click="callQuiz(time.quiz_id)"> {{'Start' | translate}} {{time.quiz_name}} </v-list-item-title>
                                            </v-list-item>
                                          </v-list-item-group>

                                        </v-list-group>

                                        <v-list-item v-else >
                                          <v-btn class="book-button" rounded fab  icon v-if="mod.show_module" @click="modulePlayer(mod.course_id,mod.module_id)"><v-icon>mdi-play-circle </v-icon></v-btn>
                                          <v-btn class="book-button" rounded fab  icon @click="lockMessage=true" lockMessage v-else ><v-icon>mdi-lock </v-icon></v-btn>
                                          <v-list-item-title :class="mod.active ? 'text-blue':'text--primary'" v-text="mod.title"></v-list-item-title>

                                          <v-btn class="pa-3" :style="{'color':primary_color}"
                                            x-small
                                            rounded
                                            outlined
                                            :color="primary_color"
                                            v-if="(mod.company_tests!=null) && mod.show_module"
                                            @click="callTest(mod.course_id,mod.module_id)"  
                                          >
                                            <v-icon>mdi-note-outline</v-icon>{{"Take Test"| translate}}
                                          </v-btn>
                                      </v-list-item>

                                      </v-list>
                                    </v-tab-item>
                                    <v-tab-item value="viewquiztab" v-if="has_quiz == true">
                                      <v-card flat>
                                            <v-sheet
                                              class="mx-auto"
                                              v-if="(dashboardcoursequizzes.hasOwnProperty(courses.course_id) ? (dashboardcoursequizzes[courses.course_id].length >0 ? true : (loadingdata ==false ? true : false) ): false )"
                                            >
                                              <v-slide-group
                                                class="pa-n5"
                                                show-arrows
                                              >
                                                <v-slide-item
                                                  v-for="(coursequizdata,coursequizindex) of dashboardcoursequizzes[courses.course_id]" 
                                                  :key="coursequizindex+''+coursequizdata.gendoc_id+''+coursequizdata.course_id"
                                                >
                                                    <v-card
                                                      class="ma-4 pa-1"
                                                      max-width="250"
                                                      width="250"
                                                      outlined
                                                    >
                                                      <v-list-item>
                                                        <v-row>
                                                        <v-col cols="7" class="pa-1">
                                                        <v-list-item-content>
                                                          <div style="color: rgba(0, 0, 0, 0.6) !important;font-size: 0.875rem !important;">
                                                            {{coursequizdata.quiz_name}}
                                                          </div>
                                                        </v-list-item-content>
                                                        </v-col>

                                                        <v-col cols="5" class="pa-1">
                                                          <v-list-item-avatar
                                                            tile
                                                            size="80"
                                                            color="grey"
                                                          >
                                                            <v-img
                                                            v-if="coursequizdata.quiz_image"
                                                            :src="company_storage_url + coursequizdata.quiz_image"
                                                          ></v-img>
                                                          </v-list-item-avatar>
                                                        </v-col>
                                                        </v-row>
                                                      </v-list-item>

                                                        <v-row>
                                                          <v-col class="pb-1 pt-0">
                                                            <v-card-actions>
                                                            <v-btn
                                                              width="220"
                                                              class="white--text"
                                                              :color="primary_color"
                                                              small
                                                              @click="callQuiz(coursequizdata.quiz_id)"
                                                            >
                                                              {{'Take Quiz'| translate}}
                                                            </v-btn>
                                                          </v-card-actions>
                                                          </v-col>
                                                        </v-row>
                                                    
                                                    </v-card>
                                                </v-slide-item>
                                              </v-slide-group>
                                            </v-sheet>
                                            <v-card-text class="pa-6" v-else>
                                              {{'No Quiz to display for this course' | translate}}
                                            </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item value="viewexertab" >
                                      <v-card flat>
                                          <v-card-text v-if="courses.company_training_exercises || courses.company_mandatory_exercises">
                                            <v-sheet
                                              class="mx-auto"
                                            >
                                              <v-slide-group
                                                class="pa-n5"
                                                show-arrows
                                              >
                                                <v-slide-item
                                                  v-for="(exercise,exerciseindex) of courses.company_mandatory_exercises" 
                                                  :key="exerciseindex+''+exercise.exercise_id+''+exercise.exercise_name"
                                                >
                                                <v-card
                                                    class="ma-1 pa-0"
                                                    max-width="210"
                                                    outlined
                                                    rel="noopener noreferrer" 
                                                    target="_blank" 
                                                    @click="callExercise(courses.course_id,exercise,'mandatory')" 
                                                  >
                                                    <v-list-item>
                                                      <v-list-item-content>
                                                        <div class="text-overline mb-2" v-if="exercise.exercise_name.length <=20">
                                                          <v-icon v-text="'mdi-file-document'"></v-icon>{{exercise.exercise_name}}
                                                        </div>
                                                        <div class="text-overline mb-2" v-else>
                                                          <v-icon v-text="'mdi-file-document'"></v-icon>{{ exercise.exercise_name | readMore(20, '...') }}
                                                        </div>
                                                      </v-list-item-content>
                                                    </v-list-item>
                                                </v-card>

                                                </v-slide-item>

                                                <v-slide-item
                                                  v-for="(exercise,exerciseindex) of courses.company_training_exercises" 
                                                  :key="exerciseindex+''+exercise.exercise_id+''+exercise.exercise_name"
                                                >
                                                <v-card
                                                    class="ma-1 pa-0"
                                                    max-width="210"
                                                    outlined
                                                    rel="noopener noreferrer" 
                                                    target="_blank" 
                                                    @click="callExercise(courses.course_id,exercise,'training')" 
                                                  >
                                                    <v-list-item>
                                                      <v-list-item-content>
                                                        <div class="text-overline mb-2" v-if="exercise.exercise_name.length <=20">
                                                          <v-icon v-text="'mdi-file-document'"></v-icon>{{exercise.exercise_name}}
                                                        </div>
                                                        <div class="text-overline mb-2" v-else>
                                                          <v-icon v-text="'mdi-file-document'"></v-icon>{{ exercise.exercise_name | readMore(20, '...') }}
                                                        </div>
                                                      </v-list-item-content>
                                                    </v-list-item>
                                                </v-card>

                                                </v-slide-item>
                                              </v-slide-group>
                                            </v-sheet>
                                      
                                          </v-card-text>
                                          <v-card-text class="pa-6" v-else>
                                              {{'No Exercise for this course' | translate}}
                                          </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item value="vieweventstab">
                                      <v-list dense v-if="Object.keys(dashboardcourseevents).length > 0 && !isLoadingEvents">
                                        <v-list-item
                                                v-for="(courseeventdata,courseeventindex) of dashboardcourseevents[courses.course_id]" 
                                                :key="courseeventindex+''+courseeventdata.gendoc_id+''+courseeventdata.course_id">
                                                  <v-list-item-subtitle  style="white-space: normal; overflow: visible; word-break: break-word;"> 
                                                    {{ courseeventdata.event_key_description }}
                                                  </v-list-item-subtitle>
                                                
                                                  <v-btn v-if="courseeventdata.status === 'not-joined'"  @click="openCalendarEvent(courseeventdata.calendar_id)" class="pa-3 mr-4" x-small rounded outlined :color="primary_color">
                                                    <v-icon>mdi-calendar </v-icon>{{"Join Event"| translate}}
                                                  </v-btn>

                                                  <v-btn small rounded disabled v-if="courseeventdata.status === 'not-joined'" >
                                                    {{'NOT JOINED' | translate}}
                                                  </v-btn>

                                                  <v-btn small rounded v-else-if="courseeventdata.status === 'joined'" color="orange" class="white--text">
                                                    {{'JOINED, NOT-ATTENDED' | translate}} 
                                                  </v-btn>

                                                  <v-btn small rounded v-else color="green" class="white--text">
                                                    {{'COMPLETED' | translate}}
                                                  </v-btn>
                                                  
                                        </v-list-item>
                                      </v-list>
                                      <v-card-text class="pa-6" v-else-if="!isLoadingEvents">
                                          {{'No Events attached to this course' | translate}}
                                      </v-card-text>
                                      <v-card-text class="pa-6" v-else>
                                          {{'Loading...' | translate}}
                                      </v-card-text>
                                    </v-tab-item>
                                    <v-tab-item value="viewlmtab">
                                      <v-card flat>
                                          <v-card-text>
                                            <v-sheet
                                              class="mx-auto"
                                              v-if="(dashboarddocuments.hasOwnProperty(courses.course_id) ? (dashboarddocuments[courses.course_id].length >0 ? true : (loadingdata ==false ? true : false) ): false )"
                                            >
                                              <v-slide-group
                                                class="pa-n5"
                                                show-arrows
                                              >
                                                <v-slide-item
                                                  v-for="(documentdata,documentindex) of dashboarddocuments[courses.course_id]" 
                                                  :key="documentindex+''+documentdata.gendoc_id+''+documentdata.course_id"
                                                >

                                                <v-card
                                                    class="ma-1 pa-0"
                                                    max-width="210"
                                                    outlined
                                                    rel="noopener noreferrer" 
                                                    target="_blank" 
                                                    :to="'/learningmaterial/'+documentdata.hash_id"
                                                  >
                                                    <v-list-item>
                                                      <v-list-item-content>
                                                        <div class="text-overline mb-2" v-if="documentdata.gendoc_name.length <=20">
                                                          <v-icon v-text="'mdi-file-document'"></v-icon>{{documentdata.gendoc_name}}
                                                        </div>
                                                        <div class="text-overline mb-2" v-else>
                                                          <v-icon v-text="'mdi-file-document'"></v-icon>{{ documentdata.gendoc_name | readMore(20, '...') }}
                                                        </div>
                                                      </v-list-item-content>
                                                    </v-list-item>
                                                </v-card>

                                                </v-slide-item>
                                              </v-slide-group>
                                            </v-sheet>
                                            <v-card-text class="pa-6" v-else>
                                              {{'No Learning Material to display for this course' | translate}}
                                            </v-card-text>
                                          </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                  </v-tabs-items>
                                </v-card>
                              </template>
                            </v-col>
                          </v-row>
                        </v-card>

                      </template>
                    </div>

                  </div>
                  <div v-else>
                    <v-row
                      class="fill-height mt-12"
                      align-content="center"
                      justify="center"
                    >
                  
                    <v-col cols="10">
                      <v-progress-linear
                        :color="primary_color"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                    </v-col>
                    <v-col
                      class="text-subtitle-1 text-center"
                      cols="12"
                    >
                      {{'Loading Course Data...' | translate}}
                    </v-col>
                    </v-row>
                   
                  </div>

        </v-col>
      </v-row>
    </v-container>

    <v-container v-else>
      <v-row  class="fill-height mt-12" align-content="center" justify="center" >
          <v-col cols="10">
            <v-progress-linear
              :color="primary_color"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            {{'Please wait. Logging you out...' | translate}}
          </v-col>
    </v-row>
    </v-container>

    <v-dialog v-if="!loadingdata && moduleQuizDialog" v-model="moduleQuizDialog" persistent>
      <v-card v-if="questions.length > 0" class="quiz-container">
        <v-stepper v-model="stage">
          <v-stepper-header>
            <v-stepper-step :complete="stage > 1" step="1">
              {{ "Instructions" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stage > 2" step="2">
              {{ "Quiz" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              {{ "Results" | translate }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
            <v-stepper-content step="1">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-row class="ma-3">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="9" sm="12">
                        <v-card-title
                          class="text-h5"
                          v-text="moduleQuiz.quiz_name"
                        ></v-card-title>
                        <v-card-subtitle
                          v-text="moduleQuiz.quiz_description"
                        ></v-card-subtitle>
                      </v-col>
                      <v-col cols="12" md="3" sm="12">
                        <v-avatar class="grey" size="125" tile>
                          <v-img
                            v-if="moduleQuiz.quiz_image"
                            :src="company_storage_url + moduleQuiz.quiz_image"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-3">
                  <v-col>
                    <div v-if="!is_daily_quiz">
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 1"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 2"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 3"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 4"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 5"| translate }}<strong>{{ moduleQuiz.passing_percentage }}%</strong></v-card-subtitle>
                    </div>
                    <div v-else>
                      <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 1"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 2"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 3"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 4"| translate}}<strong>{{ daily_quiz_question_count }}</strong></v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 5"| translate }}<strong>{{ daily_quiz_passing_percent }}%</strong></v-card-subtitle>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="ma-3" v-if="extquizdetaildata.length">
                  <v-col cols="12">
                    <div>
                      <v-divider></v-divider>
                      <DataTable
                        :title="extquizdetailtitle"
                        :headers="extquizdetailheaders"
                        :items="extquizdetaildata"
                        :footerstatus='footerstatus'
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="startStage2"
                >
                  {{ "Start" | translate }}</v-btn
                >

                <v-btn text @click="moduleQuizDialog = false">
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto pa-5"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-form ref="form">
                  <v-row
                    class="no-gutters"
                    v-for="(question, questionindex) of questions"
                    :key="questionindex"
                  >
                    <v-col>
                        <v-card-title style="word-break: break-word">{{
                          question.question_text
                        }}</v-card-title>
                        <v-card-subtitle>{{
                          question.question_help_text
                        }}</v-card-subtitle>

                        <v-card-text class="pb-0"
                          v-if="question.question_type == 'single-select'"
                        >
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-radio-group class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                  @change="checkifAnswered()"
                              >
                                <v-radio
                                  v-for="(
                                    answer, answerindex
                                  ) of question.answers"
                                  :key="answerindex"
                                  :value="answer.answer_id"
                                  :label="`${answer.answer_text}`"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text class="pb-0" v-else>
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-checkbox class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                v-for="(
                                  answer, answerindex
                                ) of question.answers"
                                :key="answerindex"
                                :value="answer.answer_id"
                                :label="`${answer.answer_text}`"
                                @change="checkifAnswered()"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="submitAnswers"
                  :disabled="!answeredAllQuestions"
                >
                  {{ "Submit" | translate }}
                </v-btn>

                <v-btn
                  text
                  @click="
                    moduleQuizDialog = false;
                    stage = 1;
                  "
                >
                  {{ "Quit" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-card
                  class="mx-auto result-box"
                  max-width="530"
                  elevation="0"
                >
                  <v-row>
                    <v-col>
                      <div>
                        <h2 class="text-center text-uppercase">
                          {{ "Result" | translate }}
                        </h2>
                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-if="quizResults.is_passed"
                        >
                          <v-icon large color="green darken-2" class="mr-2">mdi-checkbox-marked-circle</v-icon>
                          {{ "passed" | translate }}</v-card-text
                        >
                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-else
                        >
                          <v-icon large color="orange darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
                          {{ "failed" | translate }}</v-card-text
                        >
                        <v-row class="result-percentage">
                          <v-col cols="12" md="6" sm="12">
                            <v-card-text class="text-center">{{ "You scored" | translate }} {{ quizResults.scored_percentage }}%</v-card-text>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-card-text class="text-center">{{ "Percent of passing is" | translate }} {{ quizResults.passing_percentage }}%</v-card-text>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="restartQuiz(moduleQuiz.quiz_id)"
                >
                  {{ "Take Quiz Again" | translate }}
                </v-btn>

                <v-btn
                  text
                  @click="reloadData('quiz');"
                >
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <v-card v-else>
        <v-card-title>
          {{ "There is no Quiz to show" | translate }}
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="moduleQuizDialog = false"
            >{{ "Close" | translate }}</v-btn
          ></v-card-title
        >
      </v-card>
    </v-dialog>

    <v-dialog v-if="surveyDialog" v-model="surveyDialog" persistent>
      <v-card v-if="questions.length > 0" class="survey-container pa-4">
       
    
              <v-card
                class="mx-auto pa-5"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
              <v-img
               :src="storage_url + survey.survey_image"
                class="align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
                cover
              >
                <v-card-title style="color:white;" v-text="survey.survey_name"></v-card-title>
                <v-card-subtitle style="color:white;">
                {{survey.survey_description}}
              </v-card-subtitle>
              </v-img>


                <v-form ref="form" class="mt-6">
                  <v-row
                    class="no-gutters"
                    v-for="(question, questionindex) of questions"
                    :key="questionindex"
                  >
                    <v-col>
                        <v-card-title style="word-break: break-word">{{
                          question.question_text
                        }} 
                        </v-card-title>
                        <v-card-subtitle>{{
                          question.question_help_text
                        }}</v-card-subtitle>

                        <v-card-text class="pb-0"
                          v-if="question.question_type == 'single-select'"
                        >
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-radio-group class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                  @change="checkifSurveyAnswered()"
                              >
                                <v-radio
                                  v-for="(
                                    answer, answerindex
                                  ) of question.answers"
                                  :key="answerindex"
                                  :value="answer.answer_id"
                                  :label="`${answer.answer_text}`"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text class="pb-0" v-if="question.question_type == 'multiple-select'">
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-checkbox class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                v-for="(
                                  answer, answerindex
                                ) of question.answers"
                                :key="answerindex"
                                :value="answer.answer_id"
                                :label="`${answer.answer_text}`"
                                @change="checkifSurveyAnswered()"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text class="pb-0" v-if="question.question_type == 'rating'">
                          <v-row class="no-gutters">
                            <v-col cols="12">

                              <v-radio-group class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                  @change="checkifSurveyAnswered()"
                              >
                                <v-radio
                                  v-for="(
                                    answer, answerindex
                                  ) of question.answers"
                                  :key="answerindex"
                                  :value="answer.answer_id"
                                  :label="`${answer.answer_text}`"
                                ></v-radio>
                              </v-radio-group>

                            </v-col>
                          </v-row>
                        </v-card-text>

                        <v-card-text class="pb-0" v-if="question.question_type == 'text'">
                          <v-row class="no-gutters">
                            <v-col cols="12">

                              <v-textarea
                                solo
                                v-model="questionAnswers[questionindex].answer_text"
                                @change="checkifSurveyAnswered()"
                                name="textarea"
                                auto-grow
                              ></v-textarea>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                            >
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>

              <v-card
                class="mx-auto mt-2 mb-4"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="submitSurvey"
                  :disabled="!answeredAllQuestions"
                >
                  {{ "Submit" | translate }}
                </v-btn>

                <v-btn
                  text
                  @click="
                    surveyDialog = false;
                  "
                >
                  {{ "Quit" | translate }}
                </v-btn>
              </v-card>
      </v-card>
      <v-card v-else>
        <v-card-title>
          {{ "There is no Survey to show" | translate }}
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="surveyDialog = false"
            >{{ "Close" | translate }}</v-btn
          ></v-card-title
        >
      </v-card>
    </v-dialog>

    <v-dialog v-if="testExamDialog" v-model="testExamDialog" persistent>
      <v-card v-if="testExam.test_id" class="test-container">
        <v-stepper v-model="stage">
          <v-stepper-header>
            <v-stepper-step :complete="stage > 1" step="1">
              {{ "Instructions" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stage > 2" step="2">
              {{testExam.module_id? "Test" : "Exam"| translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              {{ "Results" | translate }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
            <v-stepper-content step="1">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-row class="ma-3">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="9" sm="12">
                        <v-card-title
                          class="text-h5"
                          v-text="testExam.test_name"
                        ></v-card-title>
                        <v-card-subtitle
                          v-text="testExam.test_description"
                        ></v-card-subtitle>
                      </v-col>
                      <v-col cols="12" md="3" sm="12">
                        <v-avatar class="grey" size="125" tile>
                          <v-img
                            v-if="testExam.test_image"
                            :src="company_storage_url + testExam.test_image"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-3">
                  <v-col>
                    <div>
                      <v-card-subtitle class="mb-n3">{{ "Test Instruction 1"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3" v-if="testExam.time_limit_in_minutes" >{{"Test Instruction 2"| translate}} <b>{{ testExam.time_limit_in_minutes }} {{ " Minutes" | translate}}</b></v-card-subtitle>
                      <v-card-subtitle class="mb-n3" v-else >{{"Test Instruction 6"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Test Instruction 3"| translate }}<strong>{{ testExam.passing_percentage }}%</strong></v-card-subtitle>
                      <v-card-subtitle class="mb-n3" v-if="testExam.timeout_in_minutes">{{"Test Instruction 4"| translate}} <b>{{ testExam.timeout_in_minutes }} </b> {{ "Test Instruction 5" | translate }}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3" v-else >{{"Test Instruction 7"| translate}}</v-card-subtitle>
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="startTestStage2"
                >
                  {{ "Start" | translate }}</v-btn
                >

                <v-btn text @click="testExamDialog = false">
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto sticky-container"
                max-width="800"
                outlined
                v-if="testExam.time_limit_in_minutes"
              >
              <h1 class="timer" id="timer">{{'Start' | translate}}</h1>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto pa-5 scrollable-container"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-form ref="form">
                  <v-row
                    class="no-gutters"
                    v-for="(question, questionindex) of questions"
                    :key="questionindex"
                  >
                    <v-col>
                        <v-card-title style="word-break: break-word">{{
                          question.question_text
                        }}</v-card-title>
                        <v-card-subtitle>{{
                          question.question_help_text
                        }}</v-card-subtitle>

                        <v-card-text class="pb-0"
                          v-if="question.question_type == 'single-select'"
                        >
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-radio-group class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                  @change="checkifAnswered()"
                              >
                                <v-radio
                                  v-for="(
                                    answer, answerindex
                                  ) of question.answers"
                                  :key="answerindex"
                                  :value="answer.answer_id"
                                  :label="`${answer.answer_text}`"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text class="pb-0" v-else>
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-checkbox class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                v-for="(
                                  answer, answerindex
                                ) of question.answers"
                                :key="answerindex"
                                :value="answer.answer_id"
                                :label="`${answer.answer_text}`"
                                @change="checkifAnswered()"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>

              <v-card
                class="mx-auto mt-2 footer-buttons"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="submitTestExams"
                  :disabled="!answeredAllQuestions"
                >
                  {{ "Submit" | translate }}
                </v-btn>

                <v-btn
                  text
                  @click="quitTest()"
                >
                  {{ "Quit" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-card
                  class="mx-auto result-box"
                  elevation="0"
                >
                  <v-row>
                    <v-col>
                      <div>
                        <h2 class="text-center text-uppercase">
                          {{ "Result" | translate }}
                        </h2>

                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-if="testExamResults.is_passed"
                        >
                          <v-icon large color="green darken-2" class="mr-2">mdi-checkbox-marked-circle</v-icon>
                          <span v-if="previousTestExamResults.length==1"> {{ testExam.test_message_1 | translate }}</span>
                          <span v-else-if="testExam.module_id"> {{ testExam.test_message_3 | translate }}</span>
                          <span v-else> {{ testExam.test_message_2 | translate }}</span>
                          </v-card-text
                        >
                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-else
                        >
                          <v-icon large color="orange darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
                          {{ testExam.test_message_2 | translate }}
                          </v-card-text
                        >

                        <ViewTestExamDetails
                          :testResults="testResults"
                          @closeTestExamResultDialog="closeTestExamResultDialog"
                        />

                        <v-row class="ma-3" v-if="previousTestExamResults.length">
                          <v-col cols="12">
                            <div>
                              <v-divider></v-divider>
                              <DataTable
                                :title="testExam.module_id? 'Test History' : 'Exam History' | translate"
                                :headers="testExam.module_id? testheaders:  examheaders"
                                :items="previousTestExamResults"
                              />
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  text
                  @click="reloadData('testExam')"
                >
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <v-card v-else>
        <v-card-title>
          {{ "There is no Data to show" | translate }}
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="testExamDialog = false"
            >{{ "Close" | translate }}</v-btn
          ></v-card-title
        >
      </v-card>
    
     <v-overlay :value="isTestLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    </v-dialog>
    

    <v-dialog v-if="exerciseDialog" v-model="exerciseDialog" persistent>
      <v-card v-if="exercise.exercise_id" class="test-container">
        <v-stepper v-model="stage">
          <v-stepper-header>
            <v-stepper-step :complete="stage > 1" step="1">
              {{ "Instructions" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stage > 2" step="2">
              {{"Exercise"| translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              {{ "Results" | translate }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
            <v-stepper-content step="1">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-row class="ma-3">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="9" sm="12">
                        <v-card-title
                          class="text-h5"
                          v-text="exercise.exercise_name"
                        ></v-card-title>
                        <v-card-subtitle
                          v-text="exercise.exercise_description"
                        ></v-card-subtitle>
                      </v-col>
                      <v-col cols="12" md="3" sm="12">
                        <v-avatar class="grey" size="125" tile>
                          <v-img
                            v-if="exercise.exercise_image"
                            :src="storage_url + exercise.exercise_image"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-3">
                  <v-col>
                    <div>
                      <v-card-subtitle>
                        <div class="mb-n3">
                          <p v-html="exercise.first_page_details"></p>
                        </div>
                      </v-card-subtitle>
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="startExerciseStage2"
                >
                  {{ "Start" | translate }}</v-btn
                >

                <v-btn text @click="exerciseDialog = false">
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto pa-5"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >

              <v-card-title
                class="text-h5"
                v-text="exercise.exercise_name"
              ></v-card-title>
              <v-card-subtitle
                v-text="exercise.exercise_description"
              ></v-card-subtitle>
              
              <v-card-subtitle v-if="this.exerciseResultStatus=='uploaded'" style="color: #ffa500;">
               {{ exerciseMessage }}
              </v-card-subtitle>
                      
              <v-card-subtitle>
                <div class="mb-n3">
                  <p v-html="exercise.middle_page_details"></p>
                </div>

                <div id="download-container">
                  <v-btn
                    class="white--text mt-n1"
                    :color="primary_color"
                    @click=getDownloadLink(exercise);
                  >
                    {{ "Download Exercise" | translate }}</v-btn
                  >
                </div>

                <div class="upload-exercise-container" v-if="this.exerciseResultStatus!='uploaded'">
                  <v-form id="modelform" ref="modelform">
                      <v-file-input
                        id="resource_image"
                        name="filename"
                        class="mt-6"
                        v-model="resource_image_link"
                        outlined
                        chips
                        required
                        :rules="documentRules"
                        accept="image/*,.pdf"
                        :label="'Upload Exercise Answer' | translate"
                        @change="onFileSelected"
                      >
                        <template #message="{ message }">
                        {{
                            curLanguage.lang_code == "en"
                            ? message
                            : $t(message)
                        }}
                        </template>
                      </v-file-input>
                  </v-form>
                </div>

              </v-card-subtitle>

              </v-card>

              <v-card
                class="mx-auto mt-2 footer-buttons"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="submitExercise"
                  :disabled="!answeredExercise"
                  v-if="this.exerciseResultStatus!='uploaded'"
                >
                  {{ "Submit" | translate }}
                </v-btn>

                <v-btn text @click="exerciseDialog = false; stage = 1;">
                  {{ "Close & come back later" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-card
                  class="mx-auto result-box"
                  elevation="0"
                >
                  <v-row>
                    <v-col>
                      <div>
                        <h2 class="text-center text-uppercase">
                          {{ "Result" | translate }}
                        </h2>

                        <v-card-subtitle v-if="this.exerciseResultStatus=='uploaded'">
                          <div class="mb-n3">
                            <p v-html="exercise.instruction_on_upload"></p>
                          </div>
                        </v-card-subtitle>

                        <v-card-subtitle v-if="this.exerciseResultStatus=='complete'" style="color: #008000;">
                          <div class="mb-n3">
                            <p v-html="exercise.instruction_on_grade"></p>
                          </div>
                        </v-card-subtitle>

                        <v-card-subtitle>
                          <div class="mb-n3">
                            <p v-html="exercise.last_page_details"></p>
                          </div>
                        </v-card-subtitle>
                        
                    
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  text
                  @click="reloadData('exercise')
                  "
                >
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
 
    
     <v-overlay :value="isTestLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    </v-dialog>


    <v-dialog v-model="lockMessage" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "You need to complete previous modules"| translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="lockMessage = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="messageDialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ message| translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="messageDialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="feedbackDialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ feedbackMessage| translate }}</v-card-title>
        <v-card-subtitle class="headline">{{ feedbackMessageDescription| translate }}</v-card-subtitle>
        <v-card-text>
        <span v-if="feedbackMessage=='You already passed test!'">
          {{ "If you want to check history, Click here" | translate}}
          <v-btn small class="ml-6 white--text" :color="primary_color" :to="'/test-center'" >{{ 'Jump to Test Center'| translate }}</v-btn>
        </span>
      </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="feedbackDialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="userList" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "Users Logged In" | translate }}</v-card-title>
            <v-list>
             <v-list-item-group>
                 <v-list-item
                   class="mt-2"
                   v-for="(user, i) in users"
                   :key="i"
                   :to="'/users/'+user.user_id" 
                 >
                   <v-icon color="blue" >mdi-account </v-icon> 
                   <div class="my-4 text-subtitle-1">
                      {{ user.name }}
                    </div>
                    <v-card-subtitle>({{ user.email }})</v-card-subtitle>
                 </v-list-item>
             </v-list-item-group>
            </v-list>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="userList = false"
              >
                {{ "Close" | translate }}
              </v-btn>
            </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isLoading" style="z-index: 230;">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay> 

</v-content>

</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_COMPANY_SETTINGS,
  FETCH_DASHBOARD_DATA,
  FETCH_DASHBOARD_LAST_COURSES,
  FETCH_DAILY_USER_ANSWERS,
  FETCH_DASHBOARD_DOCUMENTS,
  FETCH_DASHBOARD_QUIZ_DATA,
  FETCH_DASHBOARD_STATS_DATA,
  FETCH_DASHBOARD_QUIZ_HISTORY_DATA,
  FETCH_DASHBOARD_COURSE_QUIZ_DATA,
  FETCH_DASHBOARD_MODULE_QUIZ_DATA,
  FETCH_DASHBOARD_COURSE_EVENT_DATA,
  ADD_USER_ANSWERS,
  ADD_DAILY_USER_ANSWERS,
  FETCH_INDIVIDUAL_QUIZ,
  FETCH_QUESTION,
  FETCH_DAILY_QUIZ,
  FETCH_USERS,
  FETCH_INDIVIDUAL_SURVEY,
  FETCH_INDIVIDUAL_TEST_EXAM,
  ADD_SURVEY_USER_ANSWERS,
  ADD_TEST_EXAM_USER_ANSWERS,
  FETCH_DETAILED_INDIVIDUAL_TEST_RESULTS,
  FETCH_DETAILED_INDIVIDUAL_EXAM_RESULTS,
  FETCH_INDIVIDUAL_EXERCISE,
  DOWNLOAD_EXERCISE_TEMPLATE,
  ADD_EXERCISE_USER_ANSWERS,
  RESET_STATE
} from "@/store/actions.type";

import { SET_LOADING, SET_ROUTER_ENTER, 
  SET_SNACKBAR
 } from "@/store/mutations.type";

export default {
  name: "NewDash",
  async beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE);
    store.commit(SET_ROUTER_ENTER, false);
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Dashboard",
      search: "",
      primary_color: '',
      isLoading:false,
      company_storage_url: "",
      selectedcourses:[],
      selectedusers: [],
      filteredgroupstats:null,

      disabled: false,
      selectedItem: 1,
      ///chartjs bar
      chartData: {
        labels: [],
        datasets: [
        ]
      },
      graphvalue: [],
      // graphlabels: [],
      openedTab:[],
      has_quiz:false,
      openedPanel: {},
      activeData:{},

      //daily quiz
      stage: 1,
      moduleQuiz: [],
      questions: [],
      questionAnswers: [],
      quizResults: [],
      answeredAllQuestions: false,
      moduleQuizDialog: false,
      extquizdetaildata: [], 
      extquizdetailtitle: 'Quiz Score History',
      userList:false,
      lastcourseVisitedId: null,
      lastmoduleVisitedId:null,
      lastmoduleName:null,
      listUsers:false,
      lockMessage:null,
      is_daily_quiz:false,

      //survey
      surveyCourseId: null,
      survey: [],
      storage_url: "",
      surveyDialog: false,
      feedbackDialog: null,
      feedbackMessage: null,
      feedbackMessageDescription:null,
      surveyMetaData:null,

      message: null,
      messageDialog: null,

      //test
      lastCourseId: null,
      examCourseId: null,
      testModuleId: null,
      testExam: [],
      testExamDialog: false,
      testExamMetaData:null,
      testExamResults: [],
      countertimer:null,
      previousTestExamResults: [], 
      isTestLoading:false,

      //testexamdetailedview
      testResults:[],

      //Exercises
      exercise: [],
      exerciseDialog: false,
      resource_image_link: null,
      exercise_resource_url: null,
      answeredExercise: false,
      file: null,
      fileURL: null,
      exerciseResultStatus:null,
      exerciseResults: [],
      exerciseMessage: 'You have already uploaded the exercise. You will receive results once a examiner grades your exercise',

      //events 
      isLoadingEvents: false,
      isLoadingStats: false,
      documentRules: [
        v => !!v || 'Please upload document',
        v => (v && v.size > 0) || 'Please upload document',
      ],

    };
  },
  components: {
    Header: () => import("@/components/header/Header"),
    DashCard : () => import("@/components/cards/DashCard"),
    BarChart: () => import("@/components/charts/Bar"),
    DataTable: () => import("@/components/datatable/datatable"),
    ViewTestExamDetails: () => import("@/components/modal/ViewTestExamDetails"),
  },
  computed: {
    ...mapGetters(['currentUser','loggedin','loadingdata','companysettings','courses','coursesdata','useranswers','dashboarddocuments','timesessiondata','dashboardcoursequizzes','dashboardcourseevents','dashboardstats','lastcoursesdata','users']),
    testheaders () {
      return [
        { text: this.$t("Attempt"), value: "attempt" },  
        { text: this.$t("Test Taken on"), value: "created_at" },        
        { text: this.$t("Passing Percentage"), value: "passing_percentage" },        
        { text: this.$t("Scored Percentage"), value: "scored_percentage" },        
        { text: this.$t("Status"), value: "is_passed" },        
      ]
    },
    examheaders() {
      return [
        { text: this.$t("Attempt"), value: "attempt" },  
        { text: this.$t("Exam Taken on"), value: "created_at" },        
        { text: this.$t("Passing Percentage"), value: "passing_percentage" },        
        { text: this.$t("Scored Percentage"), value: "scored_percentage" },        
        { text: this.$t("Status"), value: "is_passed" },        
      ]
    },
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    },
  },
  created() {
    this.storage_url = process.env.VUE_APP_STORAGE_URL
    this.company_storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
  },
  async mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta);

    if(this.lastcoursesdata.length){
      this.lastcourseVisitedId = this.lastcoursesdata[0].course_id;
      this.lastmoduleVisitedId = this.lastcoursesdata[0].in_progress_module;
      let index = this.lastcoursesdata[0].company_modules.findIndex(o => o.module_id == this.lastcoursesdata[0].in_progress_module)
      this.lastmoduleName = this.lastcoursesdata[0].company_modules[index].title;
    }

    this.primary_color  = company_meta.primary_color;
    if(company_meta.hasOwnProperty('has_quiz')){
      this.has_quiz = (company_meta.has_quiz==='true') //since returned value is a tring and not boolean
    }

    if(this.companysettings.hasOwnProperty('setting_data')){
        this.daily_quiz_question_count = this.companysettings.setting_data.daily_quiz_question_count
        this.daily_quiz_passing_percent = this.companysettings.setting_data.daily_quiz_passing_percent
    }
    this.warnDisabled();

    //set the data for the daily quiz bar graph
    let scoredata = [];
    this.useranswers.forEach((element) => {
      this.graphvalue.push(element.scored_percentage);
      //Chart JS
      const month = ["Jan","Feb","March","April","May","June","July","Aug","Sept","Oct","Nov","Dec"];
      const options = { month: "short", day: "numeric" }

      let datetoconvert = element.created_at.replace(/-/g, '/').replace('T', ' ');
      let graphdate = new Date(datetoconvert);
      
      const quizdateString = graphdate.getDate() + ' ' + month[graphdate.getMonth()] + ' ' + graphdate.getFullYear();
      let quizdate = new Date(quizdateString).toLocaleDateString(this.currentUser.lang_code, options);
      
      this.chartData.labels.push(quizdate);
      scoredata.push(element.scored_percentage);
    });
    this.chartData.datasets.push({
      label: this.$t("Daily Quiz"),
      backgroundColor: this.primary_color,
      data: scoredata,
      barThickness: 10
    });

    this.openedPanel = {}
    let coursedatalength= this.coursesdata.length
    let i=0;
    while(i<coursedatalength){
      this.$set(this.openedPanel,i,[])
      i++;
    }
  
    this.isLoadingStats = true;
  
    //call slow api
    await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile'),
    await store.dispatch(FETCH_DASHBOARD_LAST_COURSES,'last-visited-courses'),
    await store.dispatch(FETCH_DAILY_USER_ANSWERS,"");
    await store.dispatch(FETCH_DASHBOARD_DATA,'subscribed-courses?course_ids'),
    await store.dispatch(FETCH_DASHBOARD_STATS_DATA,'show-statistics');
    if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3)) {
      await store.dispatch(FETCH_USERS,"?is_logged_in=true");
    }
    this.isLoadingStats = false;
  },
  methods: {
    modulePlayer(course_id,id) {
      localStorage.setItem("lastCourseVisitedId", course_id);
      this.$router.push("/course/"+course_id+"/moduleplayer/" + id);
    },
    warnDisabled() {
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 1500)
    },
    resetStats(){
      this.selectedcourses = [];
    },
    changedFilter(){
        // this.filteredgroupstats = this.groupstats.filter(v => this.selectedcourses.includes(v.group_id));  
    },
    async reloadData(type){
      switch (type) {
        case "quiz":
          this.moduleQuizDialog = false;
          break;
        case "testExam":
          this.testExamDialog = false;
          break;
        case "exercise":
          this.exerciseDialog = false;
          break;
      }
      this.stage = 1
      //reload data as new values need to be populated based on results
      await store.dispatch(FETCH_DASHBOARD_DATA,'subscribed-courses?course_ids');
    },


    async clearQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      (this.$refs[from] != undefined ? (this.date[from] = null, this.$refs[from][0].internalValue =null): null);
      (this.$refs[to] != undefined ? (this.date[to]= null, this.$refs[to][0].internalValue =null): null);
    
      this.getLockerQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to)
    },
    async getQuizData(courseindex, moduleindex, moduleid, course_id) {
      if(moduleindex==null){
        let params = {'course_id':course_id}
        await this.$store.dispatch(FETCH_DASHBOARD_COURSE_QUIZ_DATA, params).then(() => {
          this.$store.commit(SET_LOADING, false);
        });
      }
      else{
        await store.commit(SET_LOADING, true);
        if (this.activeData.hasOwnProperty(course_id) == false) {
          this.activeData[course_id] = {};
        }
        this.activeData[course_id][moduleindex] = "modulequiz";
        await this.$store.dispatch(FETCH_DASHBOARD_MODULE_QUIZ_DATA, {moduleid: moduleid, moduleindex:moduleindex, course_id:course_id}).then(() => {
          this.$store.commit(SET_LOADING, false);
          this.openPanel(courseindex, moduleindex);
        });
      }
    },
    async restartQuiz(quiz_id){
      this.stage = 1
      this.callQuiz(quiz_id)
    },
    async callQuiz(quizId) {
      this.isLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_QUIZ, quizId).then((resp1) => {
        if (resp1.success) {
          this.moduleQuiz = resp1.data;
          this.extquizdetaildata=[];
          this.fetchQuizHistory(this.moduleQuiz.quiz_type, this.moduleQuiz.quiz_type=='course'?this.moduleQuiz.course_id:this.moduleQuiz.modules[0],quizId)
        }
      });
      await store
        .dispatch(FETCH_QUESTION, "?quiz_id=" + quizId)
        .then((resp) => {
          if (resp.success) {
            store.commit(SET_LOADING, false);
            store.commit(SET_ROUTER_ENTER, false);
            //call quiz modal
            this.questions = resp.data;
            this.moduleQuizDialog = true;
            this.questionAnswers = [];
            this.answeredAllQuestions = false
            this.questions.forEach((element) => {
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_id: [],
              });
            });
            this.isLoading = false;
          }
        });
        
    },
    async getEventsData(course_id) {
        this.isLoadingEvents = true;
        let params = {'course_id':course_id}
        await this.$store.dispatch(FETCH_DASHBOARD_COURSE_EVENT_DATA, params).then(() => {
          this.$store.commit(SET_LOADING, false);
          this.isLoadingEvents = false;
        });
    },
    async openCalendarEvent(calendar_id) {
      this.$router.push("/calendar?calendar_ids="+calendar_id);
    },
    
    clicking(){
      this.$router.push("/calendar?type=personalCalendar");
    },
    async callSurvey(courseId) {
      this.startTime = new Date();
      this.isLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_SURVEY, courseId).then((resp1) => {
        if (resp1.success && resp1.data.questions) {
          this.survey = resp1.data;
          this.surveyCourseId = courseId;
          this.surveyDialog = true;
          this.questions = resp1.data.questions;
          this.questionAnswers = [] ;
          this.answeredAllQuestions = false
          this.questions.forEach((element) => {
            if(element.question_type=="text"){
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_text: [],
              });
            }
            else{
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_id: [],
              });
            }
          });
          this.isLoading = false;
        }
        else{
          this.feedbackMessage="This survey is already taken. Thank you for your feedback!";
          this.feedbackDialog=true;
          this.isLoading = false;
        }
      })
      .catch(err => {
          this.message = err.message;
          this.feedbackMessage="No Survey Found for this Course!";
          this.feedbackDialog=true;
      })
    },

    async callExam(courseId) {
        this.isTestLoading = true;
        await store.commit(SET_LOADING, true);
        await store.dispatch(FETCH_INDIVIDUAL_TEST_EXAM,courseId+'?include_questions=false&type=exam').then((resp1) => {
          if (resp1.success) {
              this.lastCourseId = courseId;
              this.testExam = resp1.data;
              this.totalTestTime = (resp1.data.time_limit_in_minutes);
              this.isTestLoading = false;
              this.testExamDialog = true;
              this.$store.commit(SET_LOADING, false)
          }
          else{
            this.feedbackMessage="Exam not found for this module. Please contact Administrator."; //might never reach here
            this.feedbackDialog=true;
          }
        })
        .catch(err => {
            this.feedbackMessage = err.response.data.message;
            this.feedbackDialog=true;
        });

    },
    async callTest(courseId,moduleId) {
      this.isTestLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_TEST_EXAM,moduleId+'?course_id='+courseId+'&include_questions=false&type=test').then((resp1) => {
        if (resp1.success) {
            this.lastCourseId = courseId;
            this.testExam = resp1.data;
            this.totalTestTime = (resp1.data.time_limit_in_minutes);
            if(moduleId){
              this.testModuleId = moduleId;
            }
            this.isTestLoading = false;
            this.testExamDialog = true;
            this.$store.commit(SET_LOADING, false)
        }
        else{
          this.feedbackMessage="Test not found for this module. Please contact Administrator."; //might never reach here
          this.feedbackDialog=true;
        }
      })
      .catch(err => {
          this.feedbackMessage = err.response.data.message;
          this.feedbackDialog=true;
      });
    },
    async startTestStage2(){
      this.isTestLoading = true;
      var tosendparams = '';
      if(this.testModuleId){
        tosendparams =  this.testModuleId + '?course_id='+this.lastCourseId+'&include_questions=true&type=test'
      }
      else{
        tosendparams =  this.lastCourseId+'?include_questions=true&type=exams'
      }
      await store.dispatch(FETCH_INDIVIDUAL_TEST_EXAM,tosendparams).then((resp1) => {
        if (resp1.success && resp1.data.questions) {
          this.startTime = new Date();
          this.countertimer = null; //Resetting timer if still on
          if(this.totalTestTime){
            this.startCountdown(this.totalTestTime);
          }
          this.questions = resp1.data.questions;
          this.questionAnswers = [] ;
          this.answeredAllQuestions = false
          this.questions.forEach((element) => {
            if(element.question_type=="text"){
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_text: [],
              });
            }
            else{
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_id: [],
              });
            }
          });
          this.isTestLoading = false;
          this.stage = 2
        }
        else{
          this.feedbackMessage="This Test is already taken.";
          this.feedbackDialog=true;
        }
      })
      .catch(err => {
          this.isTestLoading = false;
          this.testExamDialog = false;
          this.feedbackMessage = err.response.data.message;
          this.feedbackDialog=true;
      });
    },
    startCountdown(minutes) {
      var seconds = minutes * 60; // Convert minutes to seconds
      var timer = setInterval(function() {
        // Calculate remaining minutes and seconds
        var remaininghours = Math.floor(seconds / 3600);
        var remainingMinutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;

        // Display the countdown timer
        var formattedTime =
            remaininghours.toString().padStart(2, "0") +
            ":" +
            remainingMinutes.toString().padStart(2, "0") +
            ":" +
            remainingSeconds.toString().padStart(2, "0");
        document.getElementById("timer").textContent = formattedTime;

        // Decrement the timer by one second
        seconds--;
        this.timeelapsed = seconds;

        // Check if the timer has reached zero
        if (seconds < 0) {
          clearInterval(timer); // Stop the timer
        }
      }, 1000); // Update the timer every second (1000 milliseconds)

      this.countertimer = timer;

    },
    quitTest(){
      clearInterval(this.countertimer);  
      this.testExamDialog = false;
      this.stage = 1;
    },
    closeTestExamResultDialog(){
      this.testResultDialog = false
    },
    fetchQuizHistory(type,id,quizId){
      this.getLockerExtQuizData(type,id,quizId)
    },
    checkifAnswered(){
        const withNull = this.questionAnswers.filter(v => v.answer_id=="");  
        if(withNull.length==0){
            this.answeredAllQuestions = true
        }
        else{
            this.answeredAllQuestions = false
        }
    },
    checkifSurveyAnswered(){
        const withNull = this.questionAnswers.filter(v => v.answer_id ? (v.answer_id=="") : (v.answer_text==""));  
        if(withNull.length==0){
            this.answeredAllQuestions = true
        }
        else{
            this.answeredAllQuestions = false
        }
    },
    async submitAnswers() {
      this.endTime = new Date();
      var seconds = (this.endTime - this.startTime) / 1000;
      let params={
        quiz_id:this.moduleQuiz.quiz_id,
        "seconds":seconds,
        "question_answer":this.questionAnswers
      }

      let api = '';
      if(this.is_daily_quiz){
        api = ADD_DAILY_USER_ANSWERS;
      }
      else{
        api =  ADD_USER_ANSWERS;
        if(this.moduleQuiz.quiz_type=="module"){
          params['module_id']= this.moduleQuiz.modules[0]
        }
        else{
          params['course_id']= this.moduleQuiz.course_id
        }
      }

      await store
        .dispatch(api, params )
        .then((resp) => {
          if (resp != undefined && resp.success) {
            this.quizResults = resp.data;
            this.stage = 3
            this.$store.commit(SET_LOADING, false)
            this.moduleQuizDialog = true;
          } else {
            this.callQuiz(this.moduleQuiz.quiz_id);
          }
        });

      return;
    },
    async submitSurvey() {
      await store.commit(SET_LOADING, true)
      
      this.answeredAllQuestions = false
      this.endTime = new Date();
      let surveycourse = this.coursesdata[this.coursesdata.findIndex(o => o.course_id == this.surveyCourseId)];
      let surmod = []
      surveycourse.company_modules.forEach((modul) => {
          surmod.push(
              modul.module_versions.module_version_id,
          )
      });
      var seconds = (this.endTime - this.startTime) / 1000;
      let meta_questionAnswers =  [];
      this.questions.forEach((element) => {

            let metaans = [];
            this.questionAnswers.forEach((ans) => {
              if(ans.question_id == element.question_id){
                if(element.question_type=="text"){
                  metaans.push({
                      answer_text: ans.answer_text,
                  })
                }
                if(element.question_type=="multiple-select"){
                  ans.answer_id.forEach((multians) => {
                    let tempqn = element.answers[element.answers.findIndex(o => o.answer_id == multians)];
                      metaans.push({
                          answer_id: multians,
                          answer_text: tempqn.answer_text,
                      })
                  });
                }
                if(element.question_type=="rating"){
                let tempqn = element.answers[element.answers.findIndex(o => o.answer_id == ans.answer_id)];
                  metaans.push({
                      answer_id: ans.answer_id,
                      answer_text: tempqn.answer_text,
                      answer_points: tempqn.answer_points,
                  })
                }
                if(element.question_type=="single-select"){
                let tempqn = element.answers[element.answers.findIndex(o => o.answer_id == ans.answer_id)];
                  metaans.push({
                      answer_id: ans.answer_id,
                      answer_text: tempqn.answer_text,
                  })
                }
              }
           
            });
          
            if(element.question_type=="text"){
              meta_questionAnswers.push({
                question_id: element.question_id,
                question_name: element.question_name,
                question_type: element.question_type,
                question_text: element.question_text,
                answers: metaans,
              });
            }
            else{
              meta_questionAnswers.push({
                question_id: element.question_id,
                question_name: element.question_name,
                question_type: element.question_type,
                question_text: element.question_text,
                answers: metaans,
              });
            }
          });
          
      this.surveyMetaData = {
            "survey_id": this.survey.survey_id,
            "survey_name": this.survey.survey_name,
            "survey_description": this.survey.survey_description,
            "course_id" : this.surveyCourseId,
            "course_name": surveycourse.course_name,
            "question_answer" : meta_questionAnswers
        };

      let params={
        survey_id: this.survey.survey_id,
        "course_id": this.surveyCourseId,
        "module_version_ids" : surmod,
        "seconds":seconds,
        "question_answer":this.questionAnswers,
        "meta_data" : this.surveyMetaData
      }

      await store
        .dispatch(ADD_SURVEY_USER_ANSWERS, params )
        .then((resp) => {
          if (resp != undefined && resp.success) {
            this.$store.commit(SET_SNACKBAR, {status: true, message: "Survey was submitted successfully!"});
            this.surveyDialog = false;
            this.$store.commit(SET_LOADING, false)
          }
        });
      return;
    },
    async submitTestExams() {
      this.isTestLoading = true;
      clearInterval(this.countertimer);  
      await store.commit(SET_LOADING, true)
      this.answeredAllQuestions = false
      this.endTime = new Date();
      var seconds = (this.endTime - this.startTime) / 1000;
          
      let params={
        "test_id": this.testExam.test_id,
        "course_id": this.lastCourseId,
        "module_version_id" : 1,
        "seconds":seconds,
        "question_answer":this.questionAnswers,
      }

      if(this.testModuleId){
        params['module_id']= this.testModuleId; //for tests
      }

      await store
        .dispatch(ADD_TEST_EXAM_USER_ANSWERS, params )
        .then((resp) => {
          if (resp != undefined && resp.success) {
            this.$store.commit(SET_SNACKBAR, {status: true, message: "Submitted successfully!"});
            if(resp.data){
              this.previousTestExamResults = resp.data;
              this.testExamResults = this.filterObjectsByHighestAttempt(resp.data);
              this.testResults = this.filterObjectsByHighestAttempt(resp.data);
              this.testResults = this.filterObjectsByHighestAttempt(resp.data);
              this.testResults.test_name = this.testExam.test_name;
              // this.testResults = this.getTestResults(this.testExam.test_id,this.testExamResults.attempt)
            }
            this.stage = 3
            this.$store.commit(SET_LOADING, false)
            this.isTestLoading = false;
            this.testExamDialog = true;
          }
        }) 
        .catch(err => {
            this.isTestLoading = false;
            this.testExamDialog = false;
            this.feedbackMessage = err.response.data.message;
            this.feedbackDialog=true;
        });
      return;
    },
    async submitExercise() {
      this.isTestLoading = true;
      await store.commit(SET_LOADING, true)
      this.answeredAllQuestions = false
      this.endTime = new Date();
      var seconds = (this.endTime - this.startTime) / 1000;
         
      var formData = new FormData(document.getElementById("modelform"));

      formData.set("exercise_id", this.exercise.exercise_id)
      formData.set("course_id", this.lastCourseId)
      formData.set("exercise_type", this.exercise.exercise_type)
      formData.set("exercise_file", this.resource_image_link);
      formData.set("seconds", seconds)

      await store
        .dispatch(ADD_EXERCISE_USER_ANSWERS, formData )
        .then((resp) => {
          if (resp != undefined && resp.success) {
              this.$store.commit(SET_SNACKBAR, {status: true, message: "Exercise was submitted successfully!"});
            this.stage = 3
            this.exerciseResultStatus = 'uploaded';
            this.$store.commit(SET_LOADING, false)
            this.isTestLoading = false;
            this.exerciseDialog = true;
          }
        }) 
        .catch(err => {
            this.isTestLoading = false;
            this.exerciseDialog = false;
            this.feedbackMessage = err.response.data.message;
            this.feedbackDialog=true;
        });
      return;
    },
    
    async callExercise(courseId,exercise,exercise_type) {
      this.isTestLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_EXERCISE,exercise.exercise_id+'?course_id='+courseId+'&exercise_type='+exercise_type).then((resp1) => {
        if (resp1.success) {
            this.lastCourseId = courseId;
            this.exercise = resp1.data;
            this.exercise.exercise_type = exercise_type;
            this.exerciseResultStatus= resp1.data.status;
            this.exerciseResults= resp1.status;
            this.isTestLoading = false;
            this.exerciseDialog = true;
            this.$store.commit(SET_LOADING, false)
        }
      })
      .catch(err => {
          this.feedbackMessage = err.response.data.message;
          this.feedbackDialog=true;
      });
    },
    filterObjectsByHighestAttempt(data) {
      var highestAttempt = data.reduce(function(prev, current) {
        return (prev.attempt > current.attempt) ? prev : current;
      });
      return highestAttempt;
    },
    async getExamResults(testId, attempt){
      this.isLoading = true;
      await store.commit(SET_LOADING, true)
      await store.dispatch(FETCH_DETAILED_INDIVIDUAL_EXAM_RESULTS,"?test_id="+testId+"&attempt="+attempt).then((resp) => {
          if (resp.success && resp.data) {
            this.testResults = resp.data;
            this.isLoading = false;
            this.testResultDialog = true;
            this.$store.commit(SET_LOADING, false);
          }
       });
    },
    async getTestResults(testId, attempt){
      this.isLoading = true;
      await store.commit(SET_LOADING, true)
      await store.dispatch(FETCH_DETAILED_INDIVIDUAL_TEST_RESULTS,"?test_id="+testId+"&attempt="+attempt).then((resp) => {
          if (resp.success && resp.data) {
            this.testResults = resp.data;
            this.isLoading = false;
            this.testResultDialog = true;
            this.$store.commit(SET_LOADING, false);
          }
       });
    },
    details(courseid,moduleindex,index, query) {
        if(query == 'attempted'){
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Pass Score"), value:'pass_score'},
          ]  
        }
        else{
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Status"), value:'statement_query'},
          ]   
        }
        this.quizdetaildata = [this.timesessiondata[courseid][moduleindex][index]]
        this.dialog = true
    },
    async getLockerQuizData(courseindex,moduleindex,moduleid, course_id,userid,from,to){
      await store.commit(SET_LOADING, true)
      if(this.activeData.hasOwnProperty(course_id) == false){
        this.activeData[course_id] = {}
      }      
      this.activeData[course_id][moduleindex] = 'quiz'      
      await this.$store.dispatch(FETCH_DASHBOARD_QUIZ_DATA,{moduleid: moduleid, moduleindex:moduleindex, course_id:course_id, userid:userid, fromdate: (this.date[from] == undefined ? '':  this.date[from]  ), todate: (this.date[to] == undefined ? '' :this.date[to] )}).then(()=>{
        this.$store.commit(SET_LOADING, false)
        this.openPanel(courseindex,moduleindex)
      })
    }, 
    async getLockerExtQuizData(type,id,quizId){
      await store.commit(SET_LOADING, true)
      await this.$store.dispatch(FETCH_DASHBOARD_QUIZ_HISTORY_DATA,{moduleid: type=="module"?id:null,courseid: type=="module"?null:id,quiz_id:quizId}).then((resp)=>{
        this.extquizdetaildata = resp.data
        this.$store.commit(SET_LOADING, false)
        this.isLoading = false;
      })
    },    
    openPanel(courseindex,moduleindex){
      if(this.openedPanel[courseindex].indexOf(moduleindex) == -1){
        this.openedPanel[courseindex].push(moduleindex)
      }
    },
    async openDocumentPanel(searchvalue,courseid){
      let searchdata = (this.$refs[searchvalue] == undefined ? '': (this.$refs[searchvalue][0].internalValue == undefined ? '' :this.$refs[searchvalue][0].internalValue))
      await this.$store.dispatch(FETCH_DASHBOARD_DOCUMENTS,{course_id: courseid, search: searchdata}).then(() => {
        this.$store.commit(SET_LOADING, false)
        if(this.openedDocumentPanel.indexOf(courseid) == -1){
          this.openedDocumentPanel.push(courseid)
        }
      })    
    },
    closePanel(moduledata,courseindex,moduleindex,moduleid,courseid,userid){
      if(this.openedPanel[courseindex].indexOf(moduleindex) >=0){
        this.openedPanel[courseindex] = this.openedPanel[courseindex].filter(item => item!=moduleindex)
      }
      else{
        this.openPanel(courseindex,moduleindex)
        this.clearTime(moduledata,courseindex,moduleindex,moduleid, courseid, userid)
      }
    },
    play(moduledata,id) {
      if(!moduledata.show_module){
        this.lockMessage=true;
        // alert("You need to complete previous modules")
      }
      else{
        this.$router.push("/moduleplayer/" + id)
      }
    },
    async startStage2(){
      this.startTime = new Date();
      this.stage = 2
    },
    async startExerciseStage2(){
      if(this.exerciseResultStatus=='uploaded' || this.exerciseResultStatus=='complete'){
        this.stage = 3
        return;
      }
      this.startTime = new Date();
      this.stage = 2
    },
    async callDailyQuiz() {
      this.is_daily_quiz = true;
      this.isLoading = true;
      await store.commit(SET_LOADING, true);

      await store.dispatch(FETCH_DAILY_QUIZ, "").then((resp) => {
          if (resp.success) {
            store.commit(SET_LOADING, false);
            store.commit(SET_ROUTER_ENTER, false);
            //call quiz modal
            this.questions = resp.data;
            this.moduleQuizDialog = true;
            this.questionAnswers = [];
            this.answeredAllQuestions = false
            this.questions.forEach((element) => {
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_id: [],
              });
            });
            this.isLoading = false;
          }
       
        })
        .catch(err => {
            this.isLoading = false;
            this.messageDialog = err.response.data.message? true : false;
            this.message = "Your have already taken the daily quiz" ;
            this.$store.commit(SET_LOADING, false);
        })
        
    },
    onFileSelected() {
        this.resource_image_link = document.getElementById("resource_image").files[0];
        this.exercise_resource_url = URL.createObjectURL(this.resource_image_link);
        this.answeredExercise = true;
    },
    viewCourseDetails(id){
      this.$router.push("/course/" + id);
    },
    async getDownloadLink(exercise){
      // let extension = exercise.exercise_template.substring(exercise.exercise_template.lastIndexOf('.')+1);

        this.$store.dispatch(DOWNLOAD_EXERCISE_TEMPLATE, 'view-file/'+exercise.exercise_id+'?course_id='+exercise.course_id+'&user_id='+store.state.auth.user.user_id+'&exercise_type='+exercise.exercise_type).then(async resp =>{
          if(resp != undefined && resp.hasOwnProperty('success') == false){
            // if(extension == 'pdf'){
            // this.file = new Blob([resp.data], {type: 'application/pdf'});
            // this.fileURL = URL.createObjectURL(this.file);

            // let fileLink = document.createElement('a');
            // fileLink.href = this.fileURL;
            // fileLink.setAttribute('download', exercise.exercise_template);
            // const container = document.getElementById("download-container"); // Change to the ID of your container
            // container.appendChild(fileLink);
            // fileLink.click(); 
            // await this.$store.commit(SET_LOADING, false)     
            // }
            // else if(['doc','docx','ppt','pptx', 'xlsx', 'gif'].includes(extension)){
            //   let file = null;
            //   this.fileURL = URL.createObjectURL(file);
            //   if(['ppt','pptx'].includes(extension)){
            //     file = new Blob([resp.data], {type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'});
            //   }
            //   else if(['doc','docx'].includes(extension)){
            //     file = new Blob([resp.data], {type: 'application/msword'});
            //   }
            //   else if(['xlsx'].includes(extension)){
            //     file = new Blob([resp.data], {type: 'application/octet-stream'});
            //   } 
            //   else if (['gif'].includes(extension)) {
            //     file = new Blob([resp.data], { type: 'image/gif' });
            //   }            
            //   let fileLink = document.createElement('a');
            //   fileLink.href = this.fileURL;
            //   fileLink.setAttribute('download', exercise.exercise_template);
            //   const container = document.getElementById("download-container"); // Change to the ID of your container
            //   container.appendChild(fileLink);
            //   fileLink.click(); 

            //   await this.$store.commit(SET_LOADING, false)  
            // }
            // else if(['png','jpg','jpeg'].includes(extension)){
            //   this.fileURL = URL.createObjectURL(resp.data);                  
             
            //   let fileLink = document.createElement('a');
            //   fileLink.href = this.fileURL;
            //   fileLink.setAttribute('download', exercise.exercise_template);
            //   const container = document.getElementById("download-container"); // Change to the ID of your container
            //   container.appendChild(fileLink);
            //   fileLink.click(); 
            //   await this.$store.commit(SET_LOADING, false)                    
            // }
            // else{
              this.fileURL = URL.createObjectURL(resp.data);                  
             
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', exercise.exercise_template);
              const container = document.getElementById("download-container"); // Change to the ID of your container
              container.appendChild(fileLink);
              fileLink.click(); 
              await this.$store.commit(SET_LOADING, false)     
            // }
          }
        })
      
    },

    convertfromTztoDate(date){
      var dateFormat =new Date(date);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return dateFormat.toLocaleDateString(this.currentUser.lang_code, options);
    },
    //convert date function to user language specific and works for safari and firefox
    convertDate(dateString){
        const options = { year: "numeric", month: "long", day: "numeric" }
        if(!dateString){
          return;
        }
        let datetoconvert = dateString.replace(/-/g, '/').replace('T', ' ');
        let displayDate = new Date(datetoconvert);
        return new Date(displayDate).toLocaleDateString(this.currentUser.lang_code, options);
    },
    getDate(date){ //for quiz graphs
      var dateFormat =new Date(date);
      const month = ["Jan","Feb","March","April","May","June","July","Aug","Sept","Oct","Nov","Dec"];

      return(dateFormat.getDate()+
           " "+(month[dateFormat.getMonth()])+
           " "+dateFormat.getFullYear());
    },
    convertSession(dateString){
        const options = { year: "numeric", month: "numeric", day: "numeric" , hour: "numeric", minute: "numeric"}
        return new Date(dateString).toLocaleDateString(this.currentUser.lang_code, options)
    }

  }
};
</script>

<style scoped>
.v-tabs-items {
    background-color: #fafafa;
}

.card-image{
    font-size: 60px;
}

.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

.kpicards{
  border-radius: 25px;
  width:150px
}

.clickable-entity { cursor: pointer; }

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

@media (max-width: 768px) {
  .daily-quiz-bar-chart .flexible-button {
    font-size: 12px;
  }
}

@media (max-width: 540px) {
  .daily-quiz-bar-chart .flexible-button {
    font-size: 7px;
  }
}

 .timer{
  display: flex;
  justify-content: center;
} 

.sticky-container {
  position: sticky;
  top: 0;
  background-color: #fff; /* Customize as needed */
  z-index: 1; /* Ensure the sticky container is above the scrollable container */
  padding: 10px; /* Add padding as needed */
}

.scrollable-container {
  /* Add any desired styling for the scrollable container */
  max-height: 400px; /* Set a maximum height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrolling if content exceeds the container height */
}

.calendar-card{
  cursor: pointer;
}


</style>
